import classNames from 'classnames';
import { defaultTo, omit } from 'lodash-es';
import type { InputHTMLAttributes, DetailedHTMLProps, PropsWithChildren, Ref } from 'react';
import { sanitizeString } from '../../../form/form-utils';
import type { FormFieldVariant } from '../form-field-variant';

type InputProps<T> = Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'value'> & {
  value?: string | readonly string[] | number | undefined | null;
  onValueChange?: (value: T | undefined) => void;
  inputRef?: Ref<HTMLInputElement> | null;
  variant?: FormFieldVariant;
};

function Input<T = string>(props: PropsWithChildren<InputProps<T>>) {
  const variant = defaultTo(props.variant, 'default');

  return (
    <input
      ref={props.inputRef}
      {...omit(props, 'value', 'onValueChange', 'inputRef', 'variant')}
      value={props.value ?? ''}
      className={classNames(
        'w-full tds-input-value tds-input-field',
        {
          'tds-input-field-default': variant === 'default',
          'tds-input-field-small': variant === 'small',
          'tds-input-value-default': variant === 'default',
          'tds-input-value-small': variant === 'small',
        },
        props.className,
      )}
    />
  );
}

type InputTextProps = InputProps<string>;
export const InputText = (props: InputTextProps) => <Input type="text" onChange={event => props.onValueChange?.(sanitizeString(event.target.value))} {...props} />;

type InputDateProps = InputProps<string>;
export const InputDate = (props: InputDateProps) => <Input type="date" onChange={event => props.onValueChange?.(sanitizeString(event.target.value))} {...props} />;
